import { render } from "./AddPanel.vue?vue&type=template&id=223b8a60&scoped=true"
import script from "./AddPanel.vue?vue&type=script&lang=js"
export * from "./AddPanel.vue?vue&type=script&lang=js"

import "./AddPanel.vue?vue&type=style&index=0&id=223b8a60&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223b8a60"],['__file',"src/views/other/workflow/components/lFComponents/AddPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "223b8a60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('223b8a60', __exports__)) {
    console.log('reload')
    api.reload('223b8a60', __exports__)
  }
  
  module.hot.accept("./AddPanel.vue?vue&type=template&id=223b8a60&scoped=true", () => {
    console.log('re-render')
    api.rerender('223b8a60', render)
  })

}


export default __exports__